var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-tempty-data"},[_c('i',{class:'one ' + 'one-' + _vm.icon + ' ' + _vm.icon}),_c('span',{staticClass:"c-tempty-data-info"},[_vm._v("\n    "+_vm._s(_vm.info)+"\n    "),_vm._t("info")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }